export enum FUND_TYPE {
  DEPOSIT,
  WITHDRAW,
}
